import Service from '../../services/connect';
import Storage from '../../services/api/store';
import CONSTANT from '../../constant';
import Emitter from '../../services/emitter';
import _ from 'lodash';
// import { editingTarget } from '../../services/mscratch/ext';

// 扫描设备
export const DISCOVERY_DEVICE = 'DISCOVERY_DEVICE';
// 切换连接模式
export const SWITCH_CONNECT_MODE = 'SWITCH_CONNECT_MODE';
// 扫描设备
export const CONNECT_DEVICE = 'CONNECT_DEVICE';
// 断开设备连接
export const DISCONNECT_DEVICE = 'DISCONNECT_DEVICE';
// 连接状态
export const CONNECT_STATUS = 'CONNECT_STATUS';
// 连接的设备的在 mblock 里的信息
export const CONNECT_DEVICE_MBLOCK_INFO = 'CONNECT_DEVICE_MBLOCK_INFO';
// 当前连接串口
export const CONNECT_CURRENT = 'CONNECT_CURRENT';
// 重置连接设备
export const RESET_CONNECT_DEVICE = 'RESET_CONNECT_DEVICE';
// 设置是否显示筛选数据
export const SET_IS_SHOW_ALL = 'SET_IS_SHOW_ALL';

/**
 * 非蓝牙扫描
 *
 * @param {any} connectType
 * @returns
 */
const _scan = (connectType) => {
    return new Promise((resolve, reject) => {
        Service.discovery(connectType, (err, res) => {
            console.log(err, res);
            if (err) {
                reject(err);
            } else {
                if (connectType !== CONSTANT.CONNECT_TYPE.BLE) {
                    resolve(res);
                }
            }
        }, (err, res) => {
            console.log(err, res);
        });
    });
};

/**
 * 蓝牙扫描
 *
 * @param {any} connectType
 * @param {any} callback
 * @returns
 */
const _scanBle = (connectType, callback) => {
    return new Promise((resolve, reject) => {
        Service.discovery(connectType, (err, res) => {
            console.log({ err, res });
            if (err) {
                reject(err);
            } else {
                _.isFunction(callback) && callback(res);
                resolve(res);
            }
        });
    });
};

/**
 * 连接设备
 *
 * @param {any} device 连接设备
 * @param {any} type 连接类型
 * @param {any} data 连接的标识(串口|蓝牙ID|...)信息
 * @returns
 */
const _connect = (type, data) => {
    return new Promise((resolve, reject) => {
        const connectTimeout = new Map()
            .set(CONSTANT.CONNECT_TYPE.SERIAL, 5000)
            .set(CONSTANT.CONNECT_TYPE.BLE, 8000);
        setTimeout(() => { reject('timeout'); }, connectTimeout.get(type));
        Service.connect(type, data, (err, res) => {
            // console.log({ connect: { res, err } });
            if (err) {
                reject(err);
            } else {
                resolve(res);
            }
        });
    });
};

/**
 * 发现设备
 *
 * @param {any} type
 * @returns
 */
const discovery = (type) => {
    const state = {
        type: DISCOVERY_DEVICE,
        payload: {
            scanStatus: CONSTANT.SCAN_STATUS.SCANNING,
            type,
        }
    };
    if (!Service.isInstall()) {
        state.payload.status = CONSTANT.CONNECT_STATUS.NOT_SERVICE;
        state.payload.device = false;
        return state;
    }
    return async (dispatch, getState) => {
        dispatch(state);
        try {
            state.payload.scanStatus = CONSTANT.SCAN_STATUS.SCAN_SUCCESS;
            let scanData = {};
            if (type === CONSTANT.CONNECT_TYPE.BLE) {
                scanData = await _scanBle(type);
            } else {
                scanData = await _scan(type);
            }
            state.payload.scanData = {
                [type]: scanData
            };
        } catch (error) {
            state.payload.scanStatus = CONSTANT.SCAN_STATUS.SCAN_FAIL;
        }
        state.payload.isShowAll = getState().connect.isShowAll;
        if (type !== getState().connect.type) {
            return;
        }
        dispatch(state);
    };
};

/**
 * 切换连接模式
 *
 * @param {any} device
 * @param {any} type
 * @param {any} data
 * @returns
 */
const switchMode = (type) => {
    return dispatch => {
        dispatch({
            type: SWITCH_CONNECT_MODE,
            payload: {
                type,
                current: '',
                scanStatus: CONSTANT.SCAN_STATUS.SCAN_READY,
                scanData: {},
                isShowAll: false
            }
        });
    };
};

/**
 * 连接设备
 *
 * @param {any} device
 * @param {any} type
 * @param {any} data
 * @returns
 */
const connect = (device, type, data, successCb, failCb) => {
    const state = {
        type: CONNECT_DEVICE,
        payload: {
            status: CONSTANT.CONNECT_STATUS.CONNECTING
        }
    };
    return async (dispatch, getState) => {
        dispatch(state);
        // 连接前先把上一个连接的设备断开，当前仅支持单连接
        const connect = getState().connect;
        if (connect.connectionInfo && connect.connectionInfo.connectionId) {
            Service.disconnect(connect.type, connect.connectionInfo.connectionId, (err, data) => {
                console.log({ err, data });
            });
        }
        try {
            state.payload.status = CONSTANT.CONNECT_STATUS.CONNECT_FAIL;
            const connectionInfo = await _connect(type, data);
            if (connectionInfo) {
                state.payload.status = CONSTANT.CONNECT_STATUS.CONNECT_SUCCESS;
                state.payload.connectionInfo = connectionInfo;
            }
        } catch (err) {
            if (err === 'timeout') {
                state.payload.status = CONSTANT.CONNECT_STATUS.CONNECT_TIMEOUT;
            }
        }
        if (state.payload.status === CONSTANT.CONNECT_STATUS.CONNECT_SUCCESS) {
            state.payload.connectedType = type;
            state.payload.device = {
                ...device,
                address: state.payload.connectionInfo.connectionId,
                rawPort: state.payload.connectionInfo.rawPort,
            };
            // const target = editingTarget();
            dispatch(state);
            successCb && successCb();
            Emitter.emit('DeviceConnected', state.payload.device, type);
        } else {
            failCb && failCb();
            dispatch(state);
        }
    };
};

/**
 * 断开设备连接
 *
 * @param {any} type
 * @param {any} device
 * @returns
 */
const disconnect = (type, connectionId, device, isBroken = false) => {
    if (!isBroken) {
        Service.disconnect(type, connectionId, (err, data) => {
            console.log({ err, data });
        });
    }
    Storage.remove(CONSTANT.CONNECT_DEVICE_ID_KEY);
    Emitter.emit('DeviceDisconnected', device, type, isBroken);
    return {
        type: DISCONNECT_DEVICE,
        payload: {
            status: CONSTANT.CONNECT_STATUS.NOT_CONNECTED,
            device,
            isBroken
        }
    };
};

const setIsShowAll = (isShowAll) => {
    return {
        type: SET_IS_SHOW_ALL,
        payload: { isShowAll }
    };
};

/**
 * 当前连接的串口地址
 *
 * @param {any} address
 */
const current = (address) => {
    return {
        type: CONNECT_CURRENT,
        payload: { current: address }
    };
};

/**
 * 设备信息
 *
 * @param {any} device
 * @returns
 */
const setDeviceInfo = (device) => {
    return {
        type: CONNECT_DEVICE_MBLOCK_INFO,
        payload: { device }
    };
};

/**
 * 重置连接设备
 *
 */
const resetConnectDevice = (device, isRemove) => {
    return {
        type: RESET_CONNECT_DEVICE,
        payload: { device, isRemove }
    };
};

export default {
    discovery,
    switchMode,
    connect,
    disconnect,
    current,
    setDeviceInfo,
    resetConnectDevice,
    Service,
    setIsShowAll
};